import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { Point } from '@core/entities/skia/types'
import { IPin } from './IPin'

const PIN_SIZE_HEIGHT = 55 / 1.5 // 36.66px
const PIN_SIZE_WIDTH = 48 / 1.5 // 32px

export class Pin extends Entity<IPin> {
  uuid: string
  x: number
  y: number
  isNew?: boolean = false
  isBeingCreated?: boolean = false
  areaUuids?: Array<string>
  isSelected?: boolean = false
  isInitial?: boolean = false
  pinsInGroupIds?: Array<string>
  permitId?: number

  public static new(payload: IPin): Pin {
    return plainToInstance(Pin, payload)
  }

  public isInBounds(point: Point, zoom: number): boolean {
    const pinX = this.x - PIN_SIZE_WIDTH / 2
    const pinY = this.y - PIN_SIZE_HEIGHT
    const translatedByZoomWidth = PIN_SIZE_WIDTH / zoom
    const translatedByZoomHeight = PIN_SIZE_HEIGHT / zoom
    const translatedPinX = pinX - translatedByZoomWidth / 2
    const translatedPinY = pinY - translatedByZoomHeight

    return (
      point.x >= translatedPinX &&
      point.x <= translatedPinX + translatedByZoomWidth &&
      point.y >= translatedPinY &&
      point.y <= translatedPinY + translatedByZoomHeight
    )
  }

  public getTranslatedPinBounds(zoom: number): {
    x: number
    y: number
    width: number
    height: number
  } {
    const translatedByZoomWidth = PIN_SIZE_WIDTH / zoom
    const translatedByZoomHeight = PIN_SIZE_HEIGHT / zoom
    const translatedPinX = this.x - translatedByZoomWidth / 2
    const translatedPinY = this.y - translatedByZoomHeight

    return {
      x: translatedPinX,
      y: translatedPinY,
      width: translatedByZoomWidth,
      height: translatedByZoomHeight,
    }
  }
}
